// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { accountSummaryStyles } from "@steiner/App/Widgets/AccountSummary/AccountSummary";
import { fontConfig } from "@steiner/XDL/PreStyle/typography";
import { color, xScreen } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

accountSummaryStyles.container = {
    css: css`
        display: grid;
        grid-template-columns: 50% 50%;
        margin-bottom: 15px;
        ${xScreen("lte", "sm")} {
            grid-template-columns: 100%;
        }
    `,
};

const sectionTitleStyle = css`
    text-align: center;
    margin-bottom: 0;
    padding: 12px;
    border: 1px solid ${color("common.border")};
    background: ${color("common.ui2")};
`;

accountSummaryStyles.customerSectionTitle = {
    variant: "h5",
    css: css`
        ${sectionTitleStyle}
    `,
};

accountSummaryStyles.openBalancesSectionTitle = {
    variant: "h5",
    css: css`
        ${sectionTitleStyle}
        border-left: 0;
        ${xScreen("lte", "sm")} {
            grid-row: 3 / 4;
            border-top: 1px solid ${color("common.border")};
            border-left: 1px solid ${color("common.border")};
        }
    `,
};

const sectionInfoStyle = css`
    display: flex;
    flex-direction: column;
    padding: 20px 12px;
    border: 1px solid ${color("common.border")};
    gap: 5px;
`;

accountSummaryStyles.customerInfoSection = {
    css: css`
        ${sectionInfoStyle}
        border-top: 0;
        ${xScreen("lte", "sm")} {
            grid-row: 2 / 3;
            border-bottom: 0;
        }
    `,
};

accountSummaryStyles.openBalancesInfoSection = {
    css: css`
        ${sectionInfoStyle}
        border-top: 0;
        border-left: 0;
        ${xScreen("lte", "sm")} {
            border-left: 1px solid ${color("common.border")};
        }
    `,
};

accountSummaryStyles.lineWrapper = {
    css: css`
        display: flex;
        gap: 5px;
    `,
};

accountSummaryStyles.label = {
    size: 14,
    lineHeight: "19px",
    weight: fontConfig.weight.semiBold,
    css: css`
        flex: 1;
    `,
};

accountSummaryStyles.value = {
    size: 12,
    lineHeight: "19px",
    css: css`
        flex: 2;
        max-width: 150px;
    `,
};

accountSummaryStyles.totalLineWrapper = {
    css: css`
        display: flex;
        gap: 5px;
        margin-top: 20px;
    `,
};

accountSummaryStyles.totalValue = {
    size: 12,
    weight: "bold",
    lineHeight: "19px",
    css: css`
        flex: 2;
        max-width: 150px;
    `,
};
